/**
 * Web attribution pass-through for OAuth connect flows.
 * Captures ad/UTM params on page load; appendToUrl() forwards them to backend auth-start URLs.
 */
(function () {
  var KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'fbclid'
  ];

  function captureFromUrl(search) {
    var out = {};
    try {
      var params = new URLSearchParams(
        search != null ? search : window.location.search
      );
      KEYS.forEach(function (key) {
        var value = params.get(key);
        if (value == null || value === '') return;
        // fbclid must be stored exactly as received — Meta docs: "ClickID value is
        // case sensitive, do not apply any modifications before using."
        // For UTM keys trimming whitespace is safe; for fbclid we skip it entirely.
        var stored = key === 'fbclid' ? value : value.trim();
        if (stored === '') return;
        try {
          sessionStorage.setItem(key, stored);
        } catch (e) {}
        out[key] = stored;
      });
    } catch (err) {
      console.warn('[web-attribution] captureFromUrl', err);
    }
    return out;
  }

  function pickFromSession() {
    var out = {};
    KEYS.forEach(function (key) {
      try {
        var value = sessionStorage.getItem(key);
        if (value == null || String(value).trim() === '') return;
        out[key] = String(value).trim();
      } catch (e) {}
    });
    return out;
  }

  function pickFromSearch(search) {
    var out = {};
    try {
      var params = new URLSearchParams(
        search != null ? search : window.location.search
      );
      KEYS.forEach(function (key) {
        var value = params.get(key);
        if (value == null || value === '') return;
        var stored = key === 'fbclid' ? value : value.trim();
        if (stored === '') return;
        out[key] = stored;
      });
    } catch (err) {
      console.warn('[web-attribution] pickFromSearch', err);
    }
    return out;
  }

  function appendToUrl(urlString) {
    if (!urlString) return urlString;
    var tracking = pickFromSession();
    if (!Object.keys(tracking).length) return urlString;

    try {
      var u = new URL(urlString, window.location.origin);
      KEYS.forEach(function (key) {
        if (tracking[key]) u.searchParams.set(key, tracking[key]);
      });
      return u.toString();
    } catch (err) {
      var join = urlString.indexOf('?') === -1 ? '?' : '&';
      var parts = KEYS
        .filter(function (key) { return tracking[key]; })
        .map(function (key) {
          return encodeURIComponent(key) + '=' + encodeURIComponent(tracking[key]);
        });
      return parts.length ? urlString + join + parts.join('&') : urlString;
    }
  }

  function mergeIntoSession(fromSearch) {
    var fromUrl = pickFromSearch(fromSearch);
    Object.keys(fromUrl).forEach(function (key) {
      try {
        sessionStorage.setItem(key, fromUrl[key]);
      } catch (e) {}
    });
    return fromUrl;
  }

  window.NutricodeWebAttribution = {
    KEYS: KEYS,
    captureFromUrl: captureFromUrl,
    pickFromSession: pickFromSession,
    pickFromSearch: pickFromSearch,
    mergeIntoSession: mergeIntoSession,
    appendToUrl: appendToUrl
  };

  captureFromUrl();
})();
